import React from "react";

import styles from "./Backup.module.scss";

export const BackupContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.backupContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const BackupSection: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.backupSection} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const RestrictedMessage: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.restrictedMessage} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Divider: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...rest
}) => <div className={`${styles.divider} ${className ?? ""}`} {...rest} />;
